<div class="alert shadow-sm" [class]="'alert-' + type + ' text-' + align">
  <icon [name]="icon"></icon>&nbsp;&nbsp;
  <ng-content></ng-content>
</div>
